import { render, staticRenderFns } from "./Olympics.vue?vue&type=template&id=a06ab032"
import script from "./Olympics.vue?vue&type=script&lang=js"
export * from "./Olympics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports